// src/app/secure/logout/logout.component.ts

import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-logout',
  template: '', // This component has no visible content
  standalone: true
})
export class LogoutComponent implements OnInit {

  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    console.log('LogoutComponent: Signing out...');
    this.authService.signOut();
    
    // Redirect to the login page after a slight delay to ensure the session is cleared
    setTimeout(() => {
      this.router.navigate(['/login']);
      console.log('LogoutComponent: Redirecting to login page.');
    }, 100); 
  }
}